import * as fs from "fs";
import * as ko from "knockout";
import { RNSAPI } from "../../api";
import { MainViewModel } from "../../main";
import '../dataTable/dataTable';

export class CaseOverviewViewModel {
    cases = ko.observableArray([]);
    referate = ko.observableArray([]);


    async loadCases() {
      
        let cases = await RNSAPI.getCases(); 
        let referate = await RNSAPI.getReferate();
       
        this.cases(cases.Payload.Cases.map((c) => {
            this.referate(referate.Payload.Units.map((x) => {
                if (x.Id === c.Referat) {
                    c.Referat = x.Name;
                }
            }));

            c.actionHandlers = [{
                icon: "pencil",
                name: "Edit",
                action: () => MainViewModel.RoutingTable.showExtendedMainView({ caseId: c.Registernummer })
            }, {
                icon: "file-text-o",
                name: "Texterzeugung",
                action: () => MainViewModel.RoutingTable.showTextTemplateView({ caseId: c.Registernummer })
            }, {
                icon: "folder-open-o",
                name: "Einträge",
                action: () => MainViewModel.RoutingTable.showCaseEntriesView({ caseId: c.Registernummer })
            }, {
                icon: "clock-o",
                name: "Wiedervorlage",
                action: () => MainViewModel.RoutingTable.showResubmissionView({ caseId: c.Registernummer })
            }];
            return c;
        }));
    }

    constructor() {
        this.loadCases();
    }
}

let html = fs.readFileSync(__dirname + '/overview.html', 'utf8');

ko.components.register("caseoverview-view", {
    viewModel: CaseOverviewViewModel,
    template: html
});